import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContactModel } from 'shared/types/Contacts';

import { ContactsList, SelectItemsModal } from '@/components';
import { Props as ContactsListProps } from '@/components/ContactsList/types';
import { useFetchContactsFn } from '@/hooks';

import { Props } from './types';

function SelectContactsModal({
    addSelectedItemsButtonText,
    close,
    isOpen,
    onSelectContacts,
    selectedContacts,
    multiSelect,
    selectCondition,
    conditionWarning,
    contactsToSelect,
    cancel,
    displayContactInformation,
    renderExtraContentComponent,
    renderWholeContentComponent,
    selectLimit,
    externalSelectedItemsCount = 0,
    ReachedOutMaximumCapacityNode,
}: Props) {
    const { t } = useTranslation();
    const { fetchContacts } = useFetchContactsFn({ contactsToSelect });

    const availableLimit = selectLimit
        ? selectLimit - externalSelectedItemsCount
        : 0;
    const reachedOutMaximumCapacity =
        selectedContacts && selectedContacts.length >= (availableLimit || 0);

    return (
        <SelectItemsModal<ContactModel, ContactsListProps>
            fetchItemsFn={fetchContacts}
            selectedItems={selectedContacts}
            isOpen={isOpen}
            onSelectItems={onSelectContacts}
            close={close}
            emptyMessage={t('ContactsSelection:blankslate')}
            noItemsFoundMessage={t('ContactsList:no_contact_found_blankslate')}
            selectedItemsCountTextKey="Contacts:selected_contacts_number"
            addSelectedItemsButtonText={
                addSelectedItemsButtonText ||
                t(
                    multiSelect
                        ? 'Contacts:add_selected_contacts'
                        : 'Contacts:add_selected_contact',
                )
            }
            testIdPrefix="SelectContactsModal"
            title={t(
                `HorseProfile:${multiSelect ? 'select' : 'single_select'}`,
            )}
            ListComponent={ContactsList}
            listComponentProps={{
                testIdPrefix: 'SelectContactsModal',
                selectable: true,
                itemWrapperStyle: 'mb-4 min-h-[74px]',
                size: 'large',
                multiSelect,
                selectCondition,
                conditionWarning,
                displayContactInformation,
                renderExtraContentComponent,
                renderWholeContentComponent,
                selectLimit: selectLimit
                    ? selectLimit - externalSelectedItemsCount
                    : 0,
                reachedOutMaximumCapacity,
            }}
            selectLimit={selectLimit}
            externalSelectedItemsCount={externalSelectedItemsCount}
            multiSelect={multiSelect}
            onCancelButtonClick={cancel}
            ReachedOutMaximumCapacityNode={ReachedOutMaximumCapacityNode}
        />
    );
}

export default SelectContactsModal;
